<template>
    <v-navigation-drawer
        class="elevation-3"
        app
        permanent
        elevation-5
        width="100"
    >
        <!-- top-button -->
        <div class="nav__top-button">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100"
                height="70"
                fill="none"
                viewBox="0 0 100 70"
            >
                <path fill="#547685" d="M0 0h103v70H0z"></path>
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M44.962 45.955h13.832l4.115 4.875H41l3.962-4.875z"
                    clip-rule="evenodd"
                ></path>
                <path
                    fill="#547685"
                    fill-rule="evenodd"
                    d="M51.955 48.714c1.848 0 3.347-.316 3.347-.706 0-.39-1.499-.706-3.347-.706-1.85 0-3.348.316-3.348.706 0 .39 1.499.706 3.348.706z"
                    clip-rule="evenodd"
                ></path>
                <path
                    fill="#fff"
                    d="M51.955 20c-5.59 0-10.137 4.56-10.137 10.163 0 6.955 9.071 17.165 9.457 17.597a.911.911 0 0 0 1.359 0c.386-.431 9.457-10.642 9.457-17.597C62.09 24.56 57.544 20 51.955 20z"
                ></path>
                <mask
                    id="a"
                    width="22"
                    height="29"
                    x="41"
                    y="20"
                    maskUnits="userSpaceOnUse"
                >
                    <path
                        fill="#fff"
                        d="M51.955 20c-5.59 0-10.137 4.56-10.137 10.163 0 6.955 9.071 17.165 9.457 17.597a.911.911 0 0 0 1.359 0c.386-.431 9.457-10.642 9.457-17.597C62.09 24.56 57.544 20 51.955 20z"
                    ></path>
                </mask>
                <g mask="url(#a)">
                    <path
                        fill="#547685"
                        fill-rule="evenodd"
                        d="M67.588 19.671H51.955v28.721h21.701v-28.72h-6.068z"
                        clip-rule="evenodd"
                    ></path>
                </g>
                <path
                    fill="#547685"
                    fill-rule="evenodd"
                    d="M62.122 30.163C62.122 24.56 57.561 20 51.955 20c-5.607 0-10.168 4.56-10.168 10.163 0 6.955 9.099 17.166 9.486 17.597a.916.916 0 0 0 1.363 0c.387-.431 9.486-10.642 9.486-17.596zm-3.017 0c0 2.29-1.518 5.721-4.09 9.568a58.816 58.816 0 0 1-3.06 4.154 58.816 58.816 0 0 1-3.061-4.154c-2.572-3.847-4.09-7.278-4.09-9.568 0-3.937 3.21-7.146 7.15-7.146 3.94 0 7.15 3.209 7.15 7.146z"
                    clip-rule="evenodd"
                ></path>
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M62.122 30.163C62.122 24.56 57.561 20 51.955 20c-5.607 0-10.168 4.56-10.168 10.163 0 6.955 9.099 17.166 9.486 17.597a.916.916 0 0 0 1.363 0c.387-.431 9.486-10.642 9.486-17.596zM56.106 40.46a60.16 60.16 0 0 1-4.151 5.484 60.16 60.16 0 0 1-4.152-5.484c-2.705-4.047-4.31-7.675-4.31-10.297 0-4.662 3.797-8.457 8.462-8.457 4.664 0 8.461 3.795 8.462 8.457 0 2.622-1.605 6.25-4.31 10.297z"
                    clip-rule="evenodd"
                ></path>
                <path
                    fill="#fff"
                    d="M52.02 34.756c-2.604 0-4.723-2.098-4.723-4.677 0-2.58 2.119-4.677 4.723-4.677 2.604 0 4.723 2.098 4.723 4.677 0 2.58-2.119 4.677-4.723 4.677z"
                ></path>
                <path
                    fill="#547685"
                    d="M52.02 33.57a3.422 3.422 0 0 1-3.41-3.425 3.422 3.422 0 0 1 3.41-3.426c1.881 0 3.411 1.537 3.411 3.426a3.422 3.422 0 0 1-3.41 3.426z"
                ></path>
            </svg>
        </div>

        <nav class="nav">
            <!-- баланс -->
            <router-link class="nav__item" to="/balance">
                <div class="nav__icon">
                    <!-- <font-awesome-icon icon="wallet" fa-fw /> -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        class="nav__svg"
                        role="img"
                        viewBox="0 0 512 512"
                    >
                        <!-- <linearGradient id="linear-gradient">
            <stop offset="0%" stop-color="#547685"/>
            <stop offset="100%" stop-color="#82a0ae"/>
            </linearGradient>-->
                        <!-- fill="url(#linear-gradient)" -->
                        <path
                            fill="currentColor"
                            d="M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
                        ></path>
                    </svg>
                </div>

                <div class="nav__link">баланс</div>
            </router-link>

            <!-- тарифы -->
            <router-link class="nav__item" to="/tariff">
                <div class="nav__icon">
                    <!-- <font-awesome-icon icon="wallet" fa-fw /> -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        class="nav__svg"
                        role="img"
                        viewBox="-65 0 512 512"
                    >
                        <!-- <linearGradient id="linear-gradient">
            <stop offset="0%" stop-color="#547685"/>
            <stop offset="100%" stop-color="#82a0ae"/>
            </linearGradient>-->
                        <!-- fill="url(#linear-gradient)" -->
                        <path
                            fill="currentColor"
                            d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                        ></path>
                    </svg>
                </div>

                <div class="nav__link">тарифы</div>
            </router-link>

            <!-- история -->
            <router-link class="nav__item" to="/history">
                <div class="nav__icon">
                    <!-- <font-awesome-icon icon="wallet" fa-fw /> -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        class="nav__svg"
                        role="img"
                        viewBox="0 0 512 512"
                    >
                        <!-- <linearGradient id="linear-gradient">
              <stop offset="0%" stop-color="#547685"/>
              <stop offset="100%" stop-color="#82a0ae"/>
            </linearGradient>-->
                        <!-- fill="url(#linear-gradient)" -->
                        <path
                            fill="currentColor"
                            d="M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
                        ></path>
                    </svg>
                </div>

                <div class="nav__link">история</div>
            </router-link>

            <!-- устройства -->
            <router-link class="nav__item" to="/devices">
                <div class="nav__icon">
                    <!-- <font-awesome-icon icon="wallet" fa-fw /> -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        class="nav__svg"
                        role="img"
                        viewBox="-95 0 512 512"
                    >
                        <!-- <linearGradient id="linear-gradient">
              <stop offset="0%" stop-color="#547685"/>
              <stop offset="100%" stop-color="#82a0ae"/>
            </linearGradient>-->
                        <!-- fill="url(#linear-gradient)" -->
                        <path
                            fill="currentColor"
                            d="M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
                        ></path>
                    </svg>
                </div>

                <div class="nav__link">устройства</div>
            </router-link>

            <!-- настройки -->
            <router-link class="nav__item" to="/settings">
                <div class="nav__icon">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        class="nav__svg"
                        role="img"
                        viewBox="0 0 512 512"
                    >
                        <path
                            fill="currentColor"
                            d="M444.788 291.1l42.616 24.599c4.867 2.809 7.126 8.618 5.459 13.985-11.07 35.642-29.97 67.842-54.689 94.586a12.016 12.016 0 0 1-14.832 2.254l-42.584-24.595a191.577 191.577 0 0 1-60.759 35.13v49.182a12.01 12.01 0 0 1-9.377 11.718c-34.956 7.85-72.499 8.256-109.219.007-5.49-1.233-9.403-6.096-9.403-11.723v-49.184a191.555 191.555 0 0 1-60.759-35.13l-42.584 24.595a12.016 12.016 0 0 1-14.832-2.254c-24.718-26.744-43.619-58.944-54.689-94.586-1.667-5.366.592-11.175 5.459-13.985L67.212 291.1a193.48 193.48 0 0 1 0-70.199l-42.616-24.599c-4.867-2.809-7.126-8.618-5.459-13.985 11.07-35.642 29.97-67.842 54.689-94.586a12.016 12.016 0 0 1 14.832-2.254l42.584 24.595a191.577 191.577 0 0 1 60.759-35.13V25.759a12.01 12.01 0 0 1 9.377-11.718c34.956-7.85 72.499-8.256 109.219-.007 5.49 1.233 9.403 6.096 9.403 11.723v49.184a191.555 191.555 0 0 1 60.759 35.13l42.584-24.595a12.016 12.016 0 0 1 14.832 2.254c24.718 26.744 43.619 58.944 54.689 94.586 1.667 5.366-.592 11.175-5.459 13.985L444.788 220.9a193.485 193.485 0 0 1 0 70.2zM336 256c0-44.112-35.888-80-80-80s-80 35.888-80 80 35.888 80 80 80 80-35.888 80-80z"
                        ></path>
                    </svg>
                </div>

                <div class="nav__link">настройки</div>
            </router-link>
        </nav>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: 'navigation',

    data: () => ({}),
};
</script>

<style <style lang="scss" scoped>
@import '@/style/global.scss';

.nav {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    text-align: center;

    &__top-button {
        margin-bottom: 7px;
    }

    &__item {
        color: $indigo-5;
        cursor: pointer;
        margin: 15px 10px;
        position: relative;
        text-align: center;
        text-decoration: none;
        width: 100%;

        &:hover {
            color: $green-3;
        }

        &:hover::after {
            content: '';
            border: 2px solid $green-3;
            height: 110%;
            position: absolute;
            right: -10px;
            top: -10px;
        }
    }

    &__icon {
        // font-size: 32px;
        // text-align: center;
    }

    &__svg {
        height: 32px;
        width: 32px;
        // text-align: center;
    }

    &__link {
        font-family: 'Fira Sans', sans-serif;
        font-size: 12px;
        // margin-top: -5px;
    }

    .router-link-active,
    .router-link-exact-active,
    .active {
        color: $green-3;
        &::after {
            content: '';
            border: 2px solid $green-3;
            height: 110%;
            position: absolute;
            right: -10px;
            top: -10px;
        }
    }
}
</style>
